import Link from "next/link";

interface TabProps {
    activeTab: string;
    slug: string;
}
export default function Tabs({ activeTab, slug }: TabProps) {
    const activeTabStyles = "text-blue border-b-2 font-medium border-blue";
    return (
        <div className="bg-gray-light md:bg-transparent relative -mt-20 max-w-screen-lg mx-auto p-6 px-12 transition-all duration-300 rounded-xl w-full">
            <nav className="grid grid-cols md:grid-cols-3 justify-around">
                <Link href={`/kompanija/${slug}/`}>
                    <a
                        className={`text-center text-gray-dark py-4 px-6 block hover:text-blue focus:outline-none ${
                            activeTab === "o-kompaniji" && activeTabStyles
                        }`}
                    >
                        O kompaniji
                    </a>
                </Link>
                <Link href={`/kompanija/${slug}/otvorene-pozicije`}>
                    <a
                        className={`text-center text-gray-dark py-4 px-6 block hover:text-blue focus:outline-none  ${
                            activeTab === "otvorene-pozicije" && activeTabStyles
                        }`}
                    >
                        Otvorene pozicije
                    </a>
                </Link>
                <Link href={`/kompanija/${slug}/iskustva`}>
                    <a
                        className={`text-center text-gray-dark py-4 px-6 block hover:text-blue focus:outline-none  ${
                            activeTab === "iskustva" && activeTabStyles
                        }`}
                    >
                        Iskustva
                    </a>
                </Link>
                {/* <Link href={`/kompanija/${slug}/intervju`}>
                    <a
                        className={`text-center text-gray-dark py-4 px-6 block hover:text-blue focus:outline-none  ${
                            activeTab === "intervjui" && activeTabStyles
                        }`}
                    >
                        Intervjui
                    </a>
                </Link> */}
                {/* <Link href={`/kompanija/${slug}/plate`}>
                    <a
                        className={`text-center text-gray-dark py-4 px-6 block hover:text-blue focus:outline-none  ${
                            activeTab === "plate" && activeTabStyles
                        }`}
                    >
                        Plate
                    </a>
                </Link> */}
            </nav>
        </div>
    );
}
